import React, {useEffect, useState} from "react";
import {Stack} from "@mui/material";
import {ArrowRight} from "@carbon/icons-react";
import {EnvironmentConfig} from "../../common/configs/environment.config";
import {FixedRoute} from "../../common/enums/route.enum";
import CompatibilityPreview from "./compatibilityPreview";
import {ThatsMeLoadingButton} from "../buttons/thatsMeLoadingButton";
import {getRandomCelebrity} from "../../api/celebrityService";
import {Celebrity} from "../../common/models/celebrity/celebrity";
import CelebritySearchField from "./celebritySearchField";

const CelebrityComparison = () => {

    const [randomCelebrity, setRandomCelebrity] = useState<Celebrity>();

    useEffect(() => {
        let isMounted = true;

        async function randomisedCelebrity() {
            const celebrity = await getRandomCelebrity(true);
            if(!isMounted) {
                return;
            }

            setRandomCelebrity(celebrity);
        }

        void randomisedCelebrity();

        return () => {
            isMounted = false;
        };
    }, []);

    return(
        <Stack
            width={"100%"}
            pt={5}
            gap={3}
            alignItems={"start"}>
            <ThatsMeLoadingButton
                variant={"tertiary"}
                sx={{paddingX: 0, paddingY: 0}}
                href={`${EnvironmentConfig.BaseUrl}/${FixedRoute.CompatibilityCelebrity}/${randomCelebrity?.id}`}
            >
                Try with someone famous &nbsp; <ArrowRight size={20} />
            </ThatsMeLoadingButton>
            <CompatibilityPreview celebrity={randomCelebrity} />
            <CelebritySearchField/>
        </Stack>
    );
};

export default CelebrityComparison;